import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { setActiveProfile } from '../actions/ProfileList';
import { unsetActiveProfile } from '../actions/ProfileList';

const profileId = handleActions(
  {
    [setActiveProfile]: (state, action) => {
      return action.payload.profileId;
    },
    [unsetActiveProfile]: () => {
      return null;
    },
  },
  null
);
const nameLegal = handleActions(
  {
    [setActiveProfile]: (state, action) => {
      return action.payload.nameLegal;
    },
    [unsetActiveProfile]: () => {
      return null;
    },
  },
  null
);
const role = handleActions(
  {
    [setActiveProfile]: (state, action) => {
      return action.payload.role;
    },
    [unsetActiveProfile]: () => {
      return null;
    },
  },
  null
);
const roleId = handleActions(
  {
    [setActiveProfile]: (state, action) => {
      return action.payload.roleId;
    },
    [unsetActiveProfile]: () => {
      return null;
    },
  },
  ''
);
const roleKey = handleActions(
  {
    [setActiveProfile]: (state, action) => {
      return action.payload.roleKey;
    },
    [unsetActiveProfile]: (state, action) => {
      return null;
    },
  },
  ''
);

const companyId = handleActions(
  {
    [setActiveProfile]: (state, action) => {
      return action.payload.companyId;
    },
    [unsetActiveProfile]: () => {
      return null;
    },
  },
  null
);

const subject = handleActions(
  {
    [setActiveProfile]: (state, action) => {
      return action.payload.subjectId;
    },
    [unsetActiveProfile]: () => {
      return null;
    },
  },
  null
);

const activeProfile = combineReducers({
  profileId,
  nameLegal,
  role,
  roleId,
  roleKey,
  companyId,
  subject,
});

export { activeProfile };
